import React from "react";


function LocalDetalleComponents({
    data,
    handleCancelar,
    onPageChange,
    perPage = 5,
    onPerPageChange,
}) {
    const giftcardsCanjes = data?.giftcards_canjes?.data || [];

    const EmptyState = ({ message }) => (
        <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 px-4 py-3 text-sm text-gray-500">
            {message}
        </div>
    );

    const Row = ({ label, value }) => (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
            <p className="text-sm font-bold text-gray-800">{label}:</p>
            <p className="text-sm text-gray-700">{value || "-"}</p>
        </div>
    );

    return (
        <div className="rounded-xl bg-white p-6 shadow-sm border border-gray-200">
            <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
                {/* Imagen */}
                <div>
                    <div className="relative aspect-square w-full overflow-hidden rounded-2xl border border-gray-200 bg-[#f1f5f9]">
                        {data?.thumbnail ? (
                            <img
                                src={data.thumbnail}
                                alt="imagen local"
                                className="h-full w-full object-cover"
                            />
                        ) : (
                            <div className="flex h-full flex-col items-center justify-center p-6 text-center">
                                <p className="text-base font-semibold text-gray-700">No hay imagen</p>
                            </div>
                        )}
                    </div>
                    {/* {data?.codigo_qr_base_64 && (
                        <div className="mt-3 flex flex-col items-center gap-1">
                            <p className="text-xs text-gray-500 font-medium">Código QR</p>
                            <img
                                src={`data:image/svg+xml;base64,${data.codigo_qr_base_64}`}
                                alt="QR"
                                className="w-32 h-32"
                            />
                        </div>
                    )} */}
                </div>

                {/* Datos */}
                <div className="space-y-0">
                    <Row label="Razón social" value={data?.razon_social} />
                    <Row label="RUC" value={data?.ruc} />
                    <Row label="Nombre de fantasía" value={data?.nombre_fantasia} />
                    <Row label="Categoría" value={data?.nombre_categoria || data?.categoria?.nombre} />
                    <Row label="Ubicación" value={data?.ubicacion} />
                    <Row label="Teléfono" value={data?.telefono} />
                    <Row label="Cantidad máxima" value={data?.cantidad_maxima} />
                    <Row label="Descripción" value={data?.descripcion} />
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2 border-b border-gray-100">
                        <p className="text-sm font-bold text-gray-800">Teléfono con WhatsApp:</p>
                        <p className="text-sm text-gray-700">{data?.whatsapp === "1" ? "Sí" : "No"}</p>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2">
                        <p className="text-sm font-bold text-gray-800">Participa GiftCard:</p>
                        <p className="text-sm text-gray-700">{data?.participa_giftcard === "1" ? "Sí" : "No"}</p>
                    </div>
                </div>
            </div>

            {/* GiftCards canjes */}
            <div className="mt-6 pt-6 border-t border-gray-200">
                <h3 className="text-sm font-bold text-gray-800 mb-3">
                    Canjes de giftcards
                    {data?.giftcards_canjes?.total > 0 && (
                        <span className="ml-2 text-xs font-normal text-gray-500">
                            ({data.giftcards_canjes.total} total)
                        </span>
                    )}
                </h3>
                {giftcardsCanjes.length === 0 ? (
                    <EmptyState message="No hay canjes de giftcards para este local." />
                ) : (
                    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gray-50 border-b border-gray-200">
                                    <tr>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cliente</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">CI</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Código</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Monto</th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha canje</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {giftcardsCanjes.map((item, index) => (
                                        <tr key={`${item?.id || item?.codigo_giftcard || index}-${index}`} className="hover:bg-gray-50 transition-colors">
                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">
                                                {`${item?.first_name || ""} ${item?.last_name || ""}`.trim() || "-"}
                                            </td>
                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">{item?.ci || "-"}</td>
                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">{item?.codigo_giftcard || "-"}</td>
                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">{item?.monto_canjeado_format || "-"}</td>
                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">{item?.fecha_canje_format || "-"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                    </div>

                        {data?.giftcards_canjes?.total > 0 && (
                            <div className="px-4 py-3 border-t border-gray-200 bg-gray-50">
                                <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                                    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
                                        <div className="text-sm text-gray-700">
                                            Mostrando <span className="font-medium">{((data.giftcards_canjes.current_page - 1) * data.giftcards_canjes.per_page) + 1}</span> a{" "}
                                            <span className="font-medium">
                                                {Math.min(data.giftcards_canjes.current_page * data.giftcards_canjes.per_page, data.giftcards_canjes.total)}
                                            </span> de{" "}
                                            <span className="font-medium">{data.giftcards_canjes.total}</span> canjes
                                        </div>

                                        <div className="flex items-center gap-2">
                                            <span className="text-sm text-gray-600">Mostrar:</span>
                                            <select
                                                value={perPage}
                                                onChange={(e) => onPerPageChange && onPerPageChange(Number(e.target.value))}
                                                className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                            >
                                                <option value={5}>5</option>
                                                <option value={10}>10</option>
                                                <option value={15}>15</option>
                                                <option value={20}>20</option>
                                                <option value={50}>50</option>
                                            </select>
                                            <span className="text-sm text-gray-600">por página</span>
                                        </div>
                                    </div>

                                    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
                                        <div className="text-sm text-gray-700">
                                            Página <span className="font-medium">{data.giftcards_canjes.current_page}</span> de{" "}
                                            <span className="font-medium">{data.giftcards_canjes.last_page}</span>
                                        </div>

                                        <div className="flex items-center gap-2">
                                            <button
                                                onClick={() => onPageChange && onPageChange(1)}
                                                disabled={data.giftcards_canjes.current_page === 1}
                                                className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                Primera
                                            </button>
                                            <button
                                                onClick={() => onPageChange && onPageChange(data.giftcards_canjes.current_page - 1)}
                                                disabled={data.giftcards_canjes.current_page === 1}
                                                className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                Anterior
                                            </button>
                                            <button
                                                onClick={() => onPageChange && onPageChange(data.giftcards_canjes.current_page + 1)}
                                                disabled={data.giftcards_canjes.current_page === data.giftcards_canjes.last_page}
                                                className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                Siguiente
                                            </button>
                                            <button
                                                onClick={() => onPageChange && onPageChange(data.giftcards_canjes.last_page)}
                                                disabled={data.giftcards_canjes.current_page === data.giftcards_canjes.last_page}
                                                className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                Última
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <div className="flex flex-wrap items-center gap-4 pt-6 mt-6 border-t border-gray-200">
                <button
                    type="button"
                    onClick={handleCancelar}
                    className="rounded-lg bg-gray-100 px-6 py-2 font-medium text-gray-700 transition-colors hover:bg-gray-200"
                >
                    Volver
                </button>
            </div>
        </div>
    );
}

export default LocalDetalleComponents;